export const SUNBURST_AUTO_VISIBLE_DEFAULT_THRESHOLD = 10;
//# sourceMappingURL=sunburst.js.map